export const __wrapper = () => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	marginTop: 8,
})
